import React, { FC } from 'react';
import { ProgressBarProps } from './types';

const ProgressBar: FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div className="custom-progress-bar">
      <div className="custom-progress-bar__title">Upload Progress: [{progress}]%</div>
      <div className="custom-progress-bar__line">
        <div className="custom-progress-bar__line-progress"
          style={{width: `${progress}%`}}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
